import { getJSON } from 'bv-fetch';
import BaseCaptchaService from './base_captcha_service';

// Convert to 32bit integer
function stringToHash(string) {
  let hash = 0;

  if (string.length === 0) return hash;

  string.split('').forEach((char) => {
    /* eslint-disable no-bitwise */
    hash = ((hash << 5) - hash) + char.charCodeAt();
    hash &= hash;
  });

  return hash;
}

const metaTag = document.querySelector("meta[name='captcha-string']");
const captchaString = metaTag ? metaTag.getAttribute('content') : '';

export default class CustomCaptchaService extends BaseCaptchaService {
  token = stringToHash(captchaString);

  execute = () => Promise.resolve(this.token);

  shouldRetry = () => true;

  refresh = async () => {
    const response = await getJSON('/captcha_string');
    this.token = stringToHash(response.captchaString);
    return this.token;
  };
}
